export const calculateGain = (currentPrice, historicalPrice) => {
    if (currentPrice && currentPrice >0 && historicalPrice && historicalPrice > 0) {
        return Number(((currentPrice - historicalPrice) * 100)/historicalPrice).toFixed(2);
    } else {
        return 0;
    }
};